import React, {Component} from 'react';
import {Modal,ButtonToolbar,Button,FormControl,FormGroup,ControlLabel} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import Select from 'react-select'
import TextFieldModal from '../../../component/element/TextFieldModal'
import HrStore from '../../../stores/HrStore'
import EmployeeAbsenceTablePopup from '../absence/EmployeeAbsenceTablePopup'
import './tabledetail.css';
import {asyncContainer, Typeahead} from 'react-bootstrap-typeahead';
const AsyncTypeahead = asyncContainer(Typeahead);
var NotificationSystem = require('react-notification-system');

const DEDUCTION_LIST = [{label:'ประกันสังคม'},{label:'เงินสะสม'},{label:'ขาดงาน'},{label:'มาสาย'}]

class SlipEditPopup extends Component {
  constructor(...args){
    super(...args)
    let income    = [{detail:'เงินเดือนครึ่งเดือน',amount:'11000'}]
    let deduction = [{detail:'สินเชื่อ',amount:'11000'},{detail:'ประกันสังคม',amount:'2000'}]
    //let show = (typeof this.props.show!=='undefined')?this.props.show:true
    this.state = {showAbsenceForm:false,maxRow:6,name:'',loading:true,error:{income:[],deduction:[]},data:{income:[],deduction:[],summary:{}}}


    //this.loadSlipInfo(this.props.slipId)

//    store.loadAuthenBypass()
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      //this.loadSlipInfo(newProps.slipId)
    }
  }

  onShow(){
    this.loadSlipInfo(this.props.slipId)
  }

  loadSlipInfo(slipId){
    this.setState({loading:true})

    if(slipId!==''){
      HrStore.loadSlipInfo(slipId,(result)=>{
        console.log('result',result)
        if(result.data.length>0){

          let dataObj =  result.info.slip  //JSON.parse(result.data[0].data) || {}
          let name = result.data[0].first_name+" "+result.data[0].last_name
          let profile = result.info.profile;
          this.setState({data:dataObj,name:name,loading:false,profile:profile})
          console.log('dataObj',dataObj)
        }
      })
    }
  }

  getDeductionList(detail){
    let foundItem = false
    let list = DEDUCTION_LIST.map((item,index)=>{
      if(item.label===detail){
        foundItem = true
      }
      return item
    })
    if(!foundItem){
      list.push({label:detail,value:detail})
    }
    return list
  }


  onSaveClick(){
    let that = this
    let store = HrStore
    let {data} = this.state
    let {slipId} = this.props
    that.setState({loading:true,errorText:'กำลังบันทึกรายการ...'})
    store.saveSlipInfo(slipId,data,function(result){

      that.setState({loading:false,data:result.result,errorText:'บันทึกรายการเรียบร้อย'})
      setTimeout(function(){ that.setState({errorText:''}) }, 3000);
    })
  }

  onCancelClick(){
    this.onHide();    
  }

  onAddRowClick(){
    this.setState({maxRow:this.state.maxRow+1})
  }

  onDeleteRowClick(){
    let {data,name,maxRow} = this.state
    let {income,deduction,summary}    = data
    if(income.length<maxRow && deduction.length<maxRow)
      this.setState({maxRow:this.state.maxRow-1})
  }

  onAddIncomeClick(){
    let {slipId} = this.props
    let {data} = this.state
    let that = this
    var emId = data.slip.employee_id;    
    if (process.env.NODE_ENV == "development") {
     // alert('emId:'+emId)
      that.loadSlipInfo(slipId)
    }else{
      
      let url = window.API_MAIN + "/employee/incomerecord?em=" + emId+'&slip_id='+slipId;
      console.log('url:', url );
      window.load_popup_url(url, function () {
          that.loadSlipInfo(slipId)
          if(typeof that.props.onChange !=='undefined')
            that.props.onChange();
      });
    }

  }

  onAddAbsenceDeductionClick(){
    
    let {data,profile} = this.state
    if(typeof this.props.onEditAbsence!=='undefined'){
        this.props.onEditAbsence((editData,periodState,rangeText)=>{     
          
          let {rangeValue,options,year,month} = periodState
          let startDate = rangeValue.startDate,endDate = rangeValue.endDate
          if(profile.slip_per_month*1===1){
            //Find start date
            startDate = options[0].startDate
            endDate = options[options.length-1].endDate
            
            rangeText = (options[0].label+' และ ' + options[options.length-1].label + ' ' + year)
          }            
          this.refs.absencePopup.loadAbsence(editData,startDate,endDate,rangeText)
          this.setState({showAbsenceForm:true})          
        })
    }
  }

  onAddDeductionClick(){
    let {slipId} = this.props
    let {data} = this.state
    let that = this
    var emId = data.slip.employee_id;    
    if (process.env.NODE_ENV == "development") {
      //alert('emId:'+emId)
      that.loadSlipInfo(slipId)
    }else{
      
      let url = window.API_MAIN + "/employee/deductionrecord?em=" + emId+'&slip_id='+slipId;
      console.log('url:', url );
      window.load_popup_url(url, function () {
          that.loadSlipInfo(slipId)
          if(typeof that.props.onChange !=='undefined')
            that.props.onChange();
          
      });
    }
  }

  onInputChange(type,field,index,inputType,e){
    let {data,name,maxRow,error,errorText} = this.state
    let {income,deduction,summary}    = data
    console.log('onInputChange',e)
    let dataVal = ''
    if(inputType==='input')
      dataVal = e.target.value
    else{
      if(e.length==0){
        dataVal = ''
      }else{
        if(typeof e[0].removeLabel!=='undefined'){
          //Remove array
          data[type].splice(index, 1);
          this.updateSummary(data)
          this.setState({data:data})
          return;
        }else{
          dataVal = e.length>0?e[0].label:''
        }
      }
    }
    if(index>=data[type].length){
      let jsonObj = {}
      jsonObj[field] = dataVal
      data[type].push(jsonObj)
    }
    data[type][index][field] = dataVal
    if(field==='amount'){
      //Check Nan
      if(isNaN(dataVal)){
        error[type][index] = 'error'
        errorText = 'กรุณาใส่ตัวเลขเท่านั้น'
      }else{
        error[type][index] = null
        errorText = ''
      }
    }
    if(errorText==='')
      this.updateSummary(data)
    this.setState({data:data,error:error,errorText:errorText})
  }

  onSelectChange(type,field,index,value){
    let {data} = this.state
    let {income,deduction,summary}    = data
    let dataVal = value?value.value:''
    if(index>=data[type].length){
      let jsonObj = {}
      jsonObj[field] = dataVal
      data[type].push(jsonObj)
    }
    data[type][index][field] = dataVal
    this.setState({data:data})
  }

  promptTextCreator(label){
    return 'เพิ่มรายการ "'+label+'"'
  }

  updateSummary(data){
    let {income,deduction,summary}    = data
    summary.total_income = 0
    summary.round_deduction = 0
    
    income.map((item,index)=>{
      summary.total_income += item['amount']*1;
    })
    deduction.map((item,index)=>{

      summary.round_deduction += item['amount']*1;
      if(item['detail']==='เงินสะสม'){
        summary.saving_money = item['amount']
      }
    })
    summary.total_deduction = summary.round_deduction
    summary.net_income = summary.total_income - summary.total_deduction

  }

  onPrintClick(){
    let {slipId,pdfTemplate} = this.props
    if(pdfTemplate.PrintSalarySlipDoc !==undefined){
      if (process.env.NODE_ENV == "development") {
        window.open('./?startPage='+pdfTemplate.PrintSalarySlipDoc+'&ss=' + slipId , '_blank');
      }else{
          window.open('./pdf/v2/?startPage='+pdfTemplate.PrintSalarySlipDoc+'&ss=' + slipId, '_blank');
      }
    }else{
      if (process.env.NODE_ENV == "development") {
          window.open('https://demo2.bigfix.co/korat/pdf/?ss=' + slipId + '&file=salaryslip_doc', '_blank');
      }else{
          window.open('./pdf/?ss=' + slipId + '&file=salaryslip_doc', '_blank');
      }
    }
  }

  onPrintStatClick(){
    
    let {employeeId,periodState} = this.props
    let {endDate} = periodState.rangeValue
    let list = endDate.split("/");
    let year = (list[0]*1)+543

    if (process.env.NODE_ENV == "development") {
        window.open('./?startPage=PrintEmployeeWorkMonthlyReport&em=' + employeeId +'&year='+year+'&month='+list[1], '_blank');
    }else{
        window.open('./pdf/v2/?startPage=PrintEmployeeWorkMonthlyReport&em=' + employeeId+'&year='+year+'&month='+list[1], '_blank');
    }
    
  }

  onHide(){
    if(typeof this.props.onHide!=='undefined'){
      this.props.onHide()
    }else{
      this.setState({show:false})
    }
  }

  onEditIncome(benefitId,index,text,amount){
    
    let {slipId} = this.props
    let {data} = this.state
    
    var emId = data.slip.employee_id;  

    // if(benefitId*0<=0){
    //   //update Slip
    //   let fieldInfo = {title:'แก้ไขข้อมูลรายการ',title2:'จำนวน',showClear:false,index:index,benefitId:benefitId,value: text,value2:amount}
    //   this.refs.textFieldModal.loadInfo(fieldInfo)
      
    // }else{
      if(index===0 || benefitId*1===0){
        
        let fieldInfo = {title:'แก้ไขข้อมูลรายการ',title2:'จำนวนเงิน',showClear:true,index:index,benefitId:benefitId,value: text,value2:amount}
        this.refs.textFieldModal.loadInfo(fieldInfo)

      }else{
        if (process.env.NODE_ENV == "development") {
          //alert('emId:'+emId)
          this.loadSlipInfo(slipId)
        }else{
          
            let url = window.API_MAIN + "/employee/incomerecord?em=" + emId+'&id='+benefitId+'&slip_id='+slipId;
            
            window.load_popup_url(url,  ()=> {
                this.loadSlipInfo(slipId)
                if(typeof this.props.onChange !=='undefined')
                  this.props.onChange();
                
            });
          
        }
      }
   // }
  }

  onEditDeduction(benefitId,index,text,amount){
    console.log('benefitId',benefitId)
    let {slipId} = this.props
    let {data,profile} = this.state
    
    var emId = data.slip.employee_id;  

   
    if(benefitId==-1){
      if(typeof this.props.onEditAbsence!=='undefined'){
        this.props.onEditAbsence((editData,periodState,rangeText)=>{
          let {rangeValue,options,year,month} = periodState
          let startDate = rangeValue.startDate,endDate = rangeValue.endDate
          if(profile.slip_per_month*1===1){
            //Find start date
            startDate = options[0].startDate
            endDate = options[options.length-1].endDate
            
            rangeText = (options[0].label+' และ ' + options[options.length-1].label + ' ' + year)
          }
          this.refs.absencePopup.loadAbsence(editData,startDate,endDate,rangeText)
          this.setState({showAbsenceForm:true})          
        })
      }
    }else if(benefitId*1===0){
        
        let fieldInfo = {title:'แก้ไขข้อมูลรายการ',title2:'จำนวนเงิน',showClear:true,itemType:"deduction",index:index,benefitId:benefitId,value: text,value2:amount}
        this.refs.textFieldModal.loadInfo(fieldInfo)
      
    }else{
      if (process.env.NODE_ENV == "development") {
        this.loadSlipInfo(slipId)
      }else{
        let url = window.API_MAIN + "/employee/deductionrecord?em=" + emId+'&id='+benefitId+'&slip_id='+slipId;
        console.log('url:', url );
        window.load_popup_url(url,  ()=> {
            this.loadSlipInfo(slipId)
            if(typeof this.props.onChange !=='undefined')
              this.props.onChange();
            
        });
      }
    }
    
  }

  onSlipClearItem(info){
    let {data} = this.state
    if(info.itemType && info.itemType=="deduction"){
      data.deduction.splice(info.index, 1);
    }else{
      data.income.splice(info.index, 1);
    }
    info.index = -1;
    this.setState({loading:false,data:data},()=>{
      this.onSlipInfoSave(info)
    })
  }

  onSlipInfoSave(info){
    
    let {data} = this.state
    let {slipId} = this.props
    if(info.index>=0){
      if(info.itemType && info.itemType=="deduction"){
        data.deduction[info.index].detail = info.value
        data.deduction[info.index].amount = info.value2

      }else{
        data.income[info.index].detail = info.value
        data.income[info.index].amount = info.value2
      }
    }
    let incomeAmt =0
    data.income.map((item,index)=>{
      incomeAmt += item.amount*1
      return item;
    })

    let deductionAmt =0
    data.deduction.map((item,index)=>{
      deductionAmt += item.amount*1
      return item;
    })
    
    data.summary['total_income'] =  incomeAmt
    data.summary['total_deduction'] = deductionAmt
    data.slip['drawing_money'] = incomeAmt
    data.summary['net_income'] = incomeAmt - data.summary['total_deduction']*1

    HrStore.saveSlipInfo(slipId,data,(result)=>{
      this.setState({loading:false,data:data,errorText:'บันทึกรายการเรียบร้อย'})
      setTimeout(()=>{ this.setState({errorText:''}) }, 3000);
    })
    
    // this.refs.notificationSystem.addNotification({
    //   title: 'แจ้งเตือน',
    //   message: 'ทำการบันทึกรายละเอียด เรียบร้อย',
    //   level: 'info',
    //   position: 'tc',        
    // });

  
    
  }

  onAbsenceClose(changeFlag){
    this.setState({showAbsenceForm:false})
    //if(changeFlag){
    let {profile} = this.state    
    this.props.onCloseAbsence(changeFlag,profile,()=>{
      let {slipId} = this.props
      this.loadSlipInfo(slipId)    
    })
    //}
  }

  getNumber(number) {
    if (!isNaN(number))
      return number.toLocaleString(undefined, { maximumFractionDigits: 2 });
    else return number;
  }

  renderTable(summary){
    return (
      <table className="table-detail border-tbl-left border-tbl-right table-input-border-none">
      <thead>
        <tr>
          <th className="table-detail-description align-center">
            <strong>รายได้</strong>
          </th>
          <th className="table-detail-taxamount align-center">
            <strong>จำนวนเงิน</strong>
          </th>
          <th className="table-detail-number align-center" style={{width:'70px'}}>
            <strong>แก้ไข</strong>
          </th>
          <th className="table-detail-description align-center ">
            <strong>รายการหัก</strong>
          </th>
          <th className="table-detail-taxamount align-center">
            <strong>จำนวนเงิน</strong>
          </th>
          <th className="table-detail-number align-center" style={{width:'70px'}}>
            <strong>แก้ไข</strong>
          </th>
        </tr>
      </thead>
      <tbody>
        {this.renderTableData()}
      </tbody>
      <tfoot>
        <tr>
          <td className="align-left"><strong>รวมรายได้</strong></td>
          <td className="align-right "><strong>{this.getNumber(summary.total_income)}</strong></td>
          <td className="align-right "></td>
          <td className="align-left"><strong>รวมรายการหัก</strong></td>
          <td className="align-right "><strong>{this.getNumber(summary.total_deduction)}</strong></td>
          <td className="align-right "></td>
        </tr>
        <tr>
          <td colSpan="3" className="align-left"><strong></strong></td>        
          <td className="align-left"><strong>รายได้สุทธิ</strong></td>
          <td className="align-right "><strong>{this.getNumber(summary.total_income-summary.total_deduction)}</strong></td>
        </tr>

      </tfoot>
    </table>
    )
  }

  renderMenuItemChildren(label){
    console.log('renderMenuItemChildren',label)
    if(typeof label.removeLabel!=='undefined')
      return (<div><span className='text-red'>ลบรายการ : </span>{label.label}</div>)
    else
      return (<div>{label.label}</div>)
  }

  renderTableData(){
    let {data,name,maxRow,error,loading} = this.state
    let {income,deduction,summary,slip}    = data
    
    if(loading){
      return (<tr><td colSpan={4}>กำลังโหลดข้อมูล...</td></tr>)
    }

    let cdtl = []

    maxRow = income.length>maxRow?income.length:maxRow
    maxRow = deduction.length>maxRow?deduction.length:maxRow
    for (let ind = 0; ind < maxRow ; ind++) {
      let incomeDetail = '',incomeAmount = '',deductionDetail = '',deductionAmount = '',error1=null,error2=null,iBenefitId=0,dBenefitId=0;
      let readOnlyI = true,readOnlyD = true
      if (ind < income.length) {
          incomeDetail = income[ind]['detail']
          incomeAmount = income[ind]['amount']
          iBenefitId  = income[ind]['benefit_id'];
          readOnlyI = false
          console.log('income',income[ind]);
      }

      if (ind < deduction.length) {
          deductionDetail = deduction[ind]['detail']
          deductionAmount = deduction[ind]['amount']
          dBenefitId  = deduction[ind]['benefit_id'];
          readOnlyD = false
      }

      if (ind < error['income'].length){
        error1 = error['income'][ind]
      }
      if (ind < error['deduction'].length){
        error2 = error['deduction'][ind]
      }

      // if(ind==income.length)
      //   readOnlyI = false
      // if(ind==deduction.length)
      //   readOnlyD = false      
      
      
      let optionsD1 = (incomeDetail&&incomeDetail!=='')?[{label:incomeDetail}]:[{label:''}]
      let options1 = (incomeDetail&&incomeDetail!=='')?[{label:incomeDetail,removeLabel:true}]:[]
      let optionsD2 = (deductionDetail&&deductionDetail!=='')?[{label:deductionDetail}]:[{label:''}]
      let options2 = (deductionDetail&&deductionDetail!=='')?[{label:deductionDetail,removeLabel:true}]:[]

      //console.log('options1',options1)
      cdtl.push(<tr key={ind}>
        <td className="align-left ">
          <Typeahead   
              newSelectionPrefix={'เพิ่มรายการ : '}              
              allowNew={true}  
              clearButton={false}                                             
              selected={optionsD1}
              disabled={true}                                          
              options={options1}    
              emptyLabel={'พิมพ์เพื่อเพิ่มรายการ...'}    
              renderMenuItemChildren={this.renderMenuItemChildren.bind(this)}        
              onChange={this.onInputChange.bind(this,'income','detail',ind,'typeahead')}                          
            />          
        </td>
        <td className="align-right ">
          <FormGroup controlId="formValidationError1" validationState={error1}>
            <FormControl readOnly={true} onChange={this.onInputChange.bind(this,'income','amount',ind,'input')} value={incomeAmount}/>
          </FormGroup>
        </td>
        <td className='text-center'>
          <a className='text-grey' style={{display:(readOnlyI  )?'none':'block'}} onClick={this.onEditIncome.bind(this,iBenefitId,ind,incomeDetail,incomeAmount)}>
            <FontAwesome name='pencil' />แก้ไข
          </a>
        </td>
        <td className="align-left ">          
          <Typeahead     
              newSelectionPrefix={'เพิ่มรายการ : '}              
              allowNew={true}
              disabled={true}              
              selected={optionsD2}
              options={DEDUCTION_LIST}  
              renderMenuItemChildren={this.renderMenuItemChildren.bind(this)}  
              onChange={this.onInputChange.bind(this,'deduction','detail',ind,'typeahead')}                          
            />          
        </td>
        <td className="align-right ">
          <FormGroup controlId="formValidationError1" validationState={error2}>
            <FormControl readOnly={true} onChange={this.onInputChange.bind(this,'deduction','amount',ind,'input')} value={deductionAmount}/>
          </FormGroup>
        </td>
        <td className='text-center'>
          <a className='text-grey' style={{display:(readOnlyD)?'none':'block'}} onClick={this.onEditDeduction.bind(this,dBenefitId,ind,deductionDetail,deductionAmount)}>
            <FontAwesome name='pencil' />แก้ไข
          </a>
        </td>
      </tr>)
    }
    return cdtl
  }


  renderSummary(summary){
    summary = Object.assign({income_cumulative:0,tax_cumulative:0,sso_cumulative:0},summary)
    return (
      <table className="table-detail border-tbl-left border-tbl-right table-input-border-none">
        <thead>
          <tr>
            <th className="align-center bg-gray">เงินได้สะสม</th>
            <th className="align-center bg-gray">ภาษีสะสม</th>
            <th className="align-center bg-gray">ประกันสังคมสะสม</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-center">{this.getNumber(summary.income_cumulative)}</td>
            <td className="text-center">{this.getNumber(summary.tax_cumulative)}</td>
            <td className="text-center">{this.getNumber(summary.sso_cumulative)}</td>
          </tr>
        </tbody>
      </table>
    )
  }

  render(){
    let {showStat} = this.props
    let show = (typeof this.props.show!=='undefined')?this.props.show:this.state.show
    let {data,name,maxRow,error,loading,showAbsenceForm} = this.state
    let {income,deduction,summary,slip}    = data
    let label  = 'แก้ไขรายการสลิปเงินเดือน หมายเลข '+this.props.slipId+' คุณ'+name
    if(typeof slip!=='undefined'){
      label += ' ช่วงเดือน '+slip.period
    }
    

    return (
      <Modal show={show} enforceFocus={false} onShow={this.onShow.bind(this)} onHide={this.onHide.bind(this)} dialogClassName="midwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{label}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='box' >
            <div className='box-body'>
              {this.renderTable(summary)}
              {this.renderSummary(summary)}
            </div>
            <div className="overlay" style={{display:(loading?'block':'none')}}>
              <i className="fa fa-refresh fa-spin"></i>
            </div>
          </div>
          <EmployeeAbsenceTablePopup ref='absencePopup' show={showAbsenceForm} onHide={this.onAbsenceClose.bind(this)}/> 
          <TextFieldModal ref='textFieldModal'
            confirmTitle='บันทึก'
            deleteTitle="ลบรายการ"
            onClear={this.onSlipClearItem.bind(this)}
            onConfirm={this.onSlipInfoSave.bind(this)}
            />
          <NotificationSystem ref="notificationSystem" />
        </Modal.Body>
        <Modal.Footer>
          <div className='col-md-12 ' >
            <ButtonToolbar className='pull-right' >
              <Button bsStyle={null} className='bg-maroon' style={{width:'140px',display:(showStat?'':'none')}} onClick={this.onPrintStatClick.bind(this)}>
                <FontAwesome name='print'/>{' '}พิมพ์ข้อมูลทำงาน</Button>
              <Button bsStyle={null} className='bg-maroon' style={{width:'100px'}} onClick={this.onPrintClick.bind(this)}>
                <FontAwesome name='print'/>{' '}พิมพ์สลิป</Button>
              <Button bsStyle='primary' style={{width:'100px',display:'none'}} onClick={this.onSaveClick.bind(this)}>
                <FontAwesome name='save'/>{' '}บันทึก</Button>
              <Button style={{width:'100px'}} onClick={this.onCancelClick.bind(this)}>
                <FontAwesome name='close'/>{' '}ปิด</Button>

            </ButtonToolbar>
            <ButtonToolbar className='pull-left' >
              <Button bsStyle='success' style={{width:'120px'}} onClick={this.onAddIncomeClick.bind(this)}>
                <FontAwesome name='plus'/>{' '}เพิ่มรายรับ</Button>
              <Button bsStyle='warning' style={{width:'120px'}} onClick={this.onAddDeductionClick.bind(this)}>
                <FontAwesome name='minus'/>{' '}
                เพิ่มรายหัก</Button>
              <Button bsStyle='warning' style={{width:'200px'}} onClick={this.onAddAbsenceDeductionClick.bind(this)}>
                <FontAwesome name='minus'/>{' '}
                เพิ่มรายหัก (หักลางาน)</Button>  

            </ButtonToolbar>
            <div className='pull-left' style={{lineHeight:'36px'}}>
              <ControlLabel> {this.state.errorText} </ControlLabel>
            </div>
          </div>
        </Modal.Footer>
     </Modal>
    )
  }
}

SlipEditPopup.defaultProps = {
  pdfTemplate : {},
  show : false,
  showStat : false,
  periodState:null,
  employeeId:''
}

export default SlipEditPopup



// WEBPACK FOOTER //
// ./src/view/hr/slip/SlipEditPopup.js